export default "__VITE_ASSET__CC0_imlI__"